import { PricePlanTypeEnum, SubscriptionIntervalEnum } from '@systemeio/types'
import { pricePlanTypeLocoKeys } from 'modules/digital-product/price-plans/constants/price-plan-type-loco-keys'
import { PricePlanRemoveTypeDataInterface } from 'modules/digital-product/price-plans/types/price-plan-interface'
import { SubscriptionIntervalTitlesIcu } from 'modules/payment/transactions/enums/subscription-intervals-enum'
import { TICULocoType, TLocoType } from 'shared/hooks/use-loco-translation'
import { PricePlanRemoveTypeEnum } from '../enums/price-plan-remove-type-enum'

interface PricePlanListingDataInterface {
  id: PricePlanTypeEnum
  caption: string
}

export const getPricePlansTypesData = (t: TLocoType): PricePlanListingDataInterface[] =>
  Object.values(PricePlanTypeEnum).map(type => ({
    id: type,
    caption: t(pricePlanTypeLocoKeys[type]),
  }))

export const isLimitedSubscription = (type?: PricePlanTypeEnum) =>
  type === PricePlanTypeEnum.limited_subscription

/** `count` drives the plural form of the interval caption, e.g. `1 day` vs `3 days`. */
export const getSubscriptionIntervalData = (tICU: TICULocoType, count = 1) =>
  Object.keys(SubscriptionIntervalTitlesIcu).map(interval => {
    const type = interval as keyof typeof SubscriptionIntervalEnum
    return {
      id: type,
      caption: tICU(SubscriptionIntervalTitlesIcu[type], { count }),
    }
  }) as { id: SubscriptionIntervalEnum; caption: string }[]

export const getPricePlanRemoveTypeData = (t: TLocoType) =>
  [
    {
      id: PricePlanRemoveTypeEnum.from_offer,
      caption: t('dashboard.funnel.configuration.common.price_plan.remove_type.from_offer'),
    },
    {
      id: PricePlanRemoveTypeEnum.from_account,
      caption: t('dashboard.funnel.configuration.common.price_plan.remove_type.from_account'),
    },
  ] as const satisfies PricePlanRemoveTypeDataInterface[]
